import { useQuery } from "@tanstack/react-query";
import { LinaBriefingHero } from "@/components/dashboard/LinaBriefingHero";
import type { User, Company } from "@shared/schema";

export default function Team() {
  const { data: user } = useQuery<User>({ queryKey: ["/api/auth/me"] });
  const { data: company, isFetched } = useQuery<Company>({ queryKey: ["/api/companies/me"] });

  return (
    <div className="p-6 sm:p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Ihr A-Team</h1>

      <LinaBriefingHero
        companyId={company?.id || ""}
        userId={user?.id || ""}
        userName={user?.firstName || ""}
        briefing={null}
        profileMissing={isFetched && !company}
      />

      <div className="text-muted-foreground text-center py-8">
        <p>Weitere Team-Funktionen werden bald verfügbar sein.</p>
      </div>
    </div>
  );
}
